import { useCallback, useRef, useState } from "react";
import clsx from "clsx";
import { IconButton, styled } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useResize } from "hooks/useResize";
import { useToggle } from "hooks/useToggle";
import { isTruncated } from "utils/domUtils";

const Container = styled("div")({
  display: "flex",
  gap: "0.5rem",
  justifyContent: "space-between",
  alignItems: "flex-start",
  "& .expand-btn": {
    padding: 0,
  },
});

const TruncatedExpandableItems = ({ items = [], classNames = {} }) => {
  const itemsRef = useRef(null);
  const [areExpandable, setAreExpandable] = useState(false);
  const { isOpen: areExpanded, toggle: toggleExpand } = useToggle(false);

  const handleResize = useCallback(() => {
    if (!itemsRef.current) return;
    const areTruncated = isTruncated(itemsRef.current);
    setAreExpandable(areTruncated);
  }, []);

  useResize(handleResize);

  return (
    <Container className={classNames.wrapper}>
      <span
        ref={itemsRef}
        className={clsx(classNames.items, {
          "text-truncate": !areExpanded,
        })}
      >
        {items.join(", ")}
      </span>
      {areExpandable && (
        <IconButton size="small" className="expand-btn" onClick={toggleExpand}>
          {areExpanded ? (
            <KeyboardArrowUpIcon fontSize="small" />
          ) : (
            <KeyboardArrowDownIcon fontSize="small" />
          )}
        </IconButton>
      )}
    </Container>
  );
};

export default TruncatedExpandableItems;
